import React from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { Swatch } from './components/Swatch';
export function Customize(props) {
  var _props$presetColors = props.presetColors,
      presetColors = _props$presetColors === void 0 ? [] : _props$presetColors;
  var cls = usePrefixCls('color-customize');
  var headerCls = usePrefixCls('color-customize-header');
  var headerTitleCls = usePrefixCls('color-customize-header-title');
  var contentCls = usePrefixCls('color-customize-content');
  var locale = useLocale('color.custom');
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: headerCls
  }, React.createElement("div", {
    className: headerTitleCls
  }, locale)), React.createElement("div", {
    className: contentCls
  }, presetColors.map(function (color) {
    return React.createElement(Swatch, {
      key: color,
      color: color
    });
  })));
}